import React from 'react';
import { useTranslation } from 'react-i18next';

import bankIcon from '../../../assets/billingPayments/saving-bank.svg';
import checkIcon from '../../../assets/billingPayments/default-check.svg';
import creditCardIcon from '../../../assets/billingPayments/credit-card.svg';
import { PAYMENT_TYPES } from './billingAndPayments.constants';

const CurrentPaymentMethodCard = ({
  onAddPaymentMethod = () => { },
  paymentMethod = '',
  showEditButton = false,
  type = '',
}) => {
  const { t } = useTranslation('myAccount');

  return (
    <div className="Payment-method-card-container" data-default>
      <div className="Payment-method-card-default-label">
        <img alt="" src={checkIcon} />

        {t('billingAndPayments.default')}
      </div>

      <div className="Payment-method-card-data-container">
        <img
          alt=""
          className="Payment-method-card-icon"
          src={type === PAYMENT_TYPES.CREDIT_CARD ? creditCardIcon : bankIcon}
        />

        <div className="Payment-method-card-info-wrapper">
          <p className="Payment-method-card-type">
            {paymentMethod}
          </p>
        </div>
      </div>

      <div>
        {showEditButton && (
          <button
            className="Payment-method-card-tooltip-button"
            onClick={onAddPaymentMethod}
            type="button"
          >
            <div className="No-click">
              <span className="Payment-method-card-button-details">
                {t('billingAndPayments.edit')}
              </span>
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

export { CurrentPaymentMethodCard };
